import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-44c1f820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-detail-wrap" }
const _hoisted_2 = { class: "que-box" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "button-wrap" }
const _hoisted_5 = { class: "button-wrap-inner" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentIndex + 1) + "题/" + _toDisplayString(_ctx.questionIds.length) + "题", 1),
      (_ctx.currentQuestion)
        ? (_openBlock(), _createBlock(_component_question_detail, {
            key: 0,
            isWrongQuestion: true,
            showKnowledgePoint: true,
            questionData: _ctx.currentQuestion,
            onReportAction: _ctx.reportAction
          }, null, 8, ["questionData", "onReportAction"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevQuestion && _ctx.prevQuestion(...args))),
          class: _normalizeClass({'disabled': _ctx.currentIndex === 0})
        }, "上一题", 2),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextQuestion && _ctx.nextQuestion(...args))),
          class: _normalizeClass({'disabled': _ctx.currentIndex === _ctx.questionIds.length - 1})
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_van_loading, { key: 0 }))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "下一题"))
        ], 2)
      ])
    ])
  ]))
}